
export default {
  name: 'MarqueeText',
  props: {
    text: { type: String, required: true },
    speed: { type: Number, default: 30 },
  },
  data() {
    return { x: 0, unit: 0, copies: 6, last: 0, raf: 0 };
  },
  mounted() {
    this.$nextTick(() => {
      this.measure();
      this.fill();
      this.last = performance.now ? performance.now() : Date.now();
      const loop = (t) => {
        const now = t || Date.now();
        const dt = (now - this.last) / 1000;
        this.last = now;
        this.x -= this.speed * dt;
        if (this.unit && -this.x >= this.unit) this.x += this.unit;
        this.raf = requestAnimationFrame(loop);
      };
      this.raf = requestAnimationFrame(loop);
      window.addEventListener('resize', this.onResize, { passive: true });
    });
  },
  beforeDestroy() {
    if (this.raf) cancelAnimationFrame(this.raf);
    window.removeEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    if (this.raf) cancelAnimationFrame(this.raf);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      const prev = this.unit;
      this.measure();
      this.fill();
      if (prev && this.unit)
        this.x = -(((-this.x % this.unit) + this.unit) % this.unit);
    },
    measure() {
      const first = this.$refs.track?.querySelector('.marquee__unit');
      this.unit = first ? first.offsetWidth : 0;
    },
    fill() {
      const w = this.$refs.root?.offsetWidth || 0;
      if (!w || !this.unit) return;
      this.copies = Math.max(6, Math.ceil((w * 2) / this.unit));
    },
  },
};
